import { Box, Skeleton, styled } from '@mui/material';
import PropTypes from 'prop-types';
import { FC, ReactNode, Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import DNavbar from './DNavbar';
import DSidebar from './DSidebar';
import FullScreenLoader from '@/components/Layout/FullScreenLoader';


interface DashboardLayoutProps {
    children?: ReactNode;
}

const DashboardLayoutRoot = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    maxWidth: '100%',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
        paddingLeft: 250
    }
}));


const DashboardLayout: FC<DashboardLayoutProps> = ({ children }) => {
    const [isSidebarOpen, setSidebarOpen] = useState(true);

    const navbarHeight = 64;


    return (<>
        <DNavbar onSidebarOpen={() => setSidebarOpen(true)} navbarHeight={navbarHeight} />

        <DashboardLayoutRoot>
            <Box
                sx={{
                    width: '100%',
                    margin: '0 auto',
                    height: `calc(100vh - ${navbarHeight}px)`,
                    overflowY: 'scroll',
                }}
                component='main'
            >
                <Suspense fallback={
                    <FullScreenLoader />
                }>
                    <Outlet />
                </Suspense>
            </Box>


        </DashboardLayoutRoot>
        <DSidebar
            onClose={() => setSidebarOpen(false)}
            open={isSidebarOpen}

        />
    </>
    );
};

DashboardLayout.propTypes = {
    children: PropTypes.element
};

export default DashboardLayout;


